import React from "react";
import cx from "classnames";
import { Row, Col, FormGroup } from "react-bootstrap";

import Button from "src/components/button";
import isEqual from "is-equal";
import _ from "lodash";

import contentStyle from "./DescriptionContentEditor.module.scss";

import styles from "./Style.module.scss";
import { localizedStrings } from "src/localization";
import RichTextEditor from "src/components/richTextEditor";
import { InputWithIcon } from "src/components/input";

import TinyMCE from "react-tinymce";

class NDADetailsView extends React.Component {
  constructor(props) {
    super(props);

    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizedSettings = localizedStrings.pages.settings;
    this.localizedNda = this.localizedSettings.templates.nda;
    this.editor = null;

    this.state = {
      create: this.props.template == null,
      name: _.get(
        this.props,
        "template.name",
        this.localizedSettings.templates.email.untitled,
      ),
      title: _.get(this.props, "template.title", " "),
      description: _.get(this.props, "template.description", " "),
      errors: {},
    };

    this._handleDescriptionChange = this._handleDescriptionChange.bind(this);
    this._handleChange = this._handleChange.bind(this);
    this._handleSaveClick = this._handleSaveClick.bind(this);
    this._handleResetClick = this._handleResetClick.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.template, nextProps.template)) {
      this.setState({
        errors: {},
        create: nextProps.template == null,
        name: _.get(
          nextProps,
          "template.name",
          this.localizedSettings.templates.email.untitled,
        ),
        title: _.get(nextProps, "template.title", " "),
        description: _.get(nextProps, "template.description", " "),
      });
    }

    if (!this.props.created && nextProps.created) {
      this.props.navigate(`/settings/nda-templates/${nextProps.created.id}`);
    }
  }

  _handleDescriptionChange(e) {
    this.setState({
      description: e.target.getContent(),
    });
  }

  _handleChange(field, e) {
    let value = e.target.value;
    this.setState({
      [field]: value,
    });
  }

  _validateForm() {
    var errors = {};
    if (this.state.name.trim() == "") {
      errors["name"] = this.localizedNda.form.error_message;
    }

    return errors;
  }

  _handleSaveClick() {
    var errors = this._validateForm();

    if (Object.keys(errors).length != 0) {
      this.setState({
        errors: errors,
      });

      return;
    }

    const request = {
      name: this.state.name,
      title: this.state.title,
      description: this.state.description,
    };

    if (this.state.create) {
      this.props.createNDATemplate(request);
      this.setState({
        errors: {},
      });
    } else {
      this.props.updateNDATemplate(this.props.id, request);
      this.setState({
        errors: {},
      });
    }
  }

  _handleResetClick() {
    if (this.state.create) {
      var url = "/settings/nda-templates";
      if (this.props.templates && this.props.templates.length > 0) {
        url = `/settings/nda-templates/${this.props.templates[0].id}`;
      }

      this.props.navigate(url);

      return;
    }

    this.setState({
      create: this.props.template == null,
      name: _.get(
        this.props,
        "template.name",
        this.localizedSettings.templates.email.untitled,
      ),
      title: _.get(this.props, "template.title", " "),
      description: _.get(this.props, "template.description", " "),
    });
  }

  render() {
    return (
      <div className={styles.content}>
        <h3>
          {this.state.create
            ? this.localizedNda.create_nda
            : this.localizedNda.update_nda}
        </h3>
        <Row className={cx(styles.row)}>
          <Col md={12}>
            <FormGroup className={cx(styles.formGroup)}>
              <InputWithIcon
                value={this.state.name}
                onChange={this._handleChange.bind(this, "name")}
                placeholder={this.localizedNda.form.template_name}
              />
            </FormGroup>
            {this.state.errors["name"] && (
              <div className={styles.error}>
                <i className="paperflite-warning" />
                {this.state.errors["name"]}
              </div>
            )}

            <FormGroup className={cx(styles.formGroup)}>
              <InputWithIcon
                value={
                  this.state.title && this.state.title.trim() != ""
                    ? this.state.title
                    : ""
                }
                onChange={this._handleChange.bind(this, "title")}
                placeholder={this.localizedNda.form.title}
              />
            </FormGroup>
            <span className={styles.error}>
              {this.state.errors.title || ""}
            </span>
          </Col>
          <Col md={12}>
            <label className={styles.msgDescription}>
              {this.localizedNda.form.nda_description}
            </label>
            <p className={styles.helptext}>{this.localizedNda.form.sub_text}</p>
          </Col>
          <Col md={12} className={styles.editor}>

          <TinyMCE
            key={`ndaDescription-${this.props.id}`}
            content={this.state.description}
            className={styles.ndaEditor}
            customFontStyle={contentStyle}
            config={{
              branding: false,
              statusbar: false,
              plugins: 'noneditable, variable, widget,  autolink, link, image, code, textcolor, lists, paste',
              menubar: false,
              toolbar: 'undo redo | bold italic  | alignleft aligncenter alignright | forecolor backcolor | fontselect | fontsizeselect ',
              resize: false,
              height: 300,           
              default_link_target: "_blank",
              fontsize_formats: '5pt 5.5pt 6.5pt 7.5pt 8pt 9pt 10pt 10.5pt 11pt 12pt 14pt 16pt 18pt 20pt 22pt 24pt 26pt 28pt 36pt 48pt 72pt',
              paste_retain_style_properties: "color",
              resize: false,
              browser_spellcheck : true,
              convert_urls: false,
              relative_urls: false,
              remove_script_host: false,    
              }}
              onChange={this._handleDescriptionChange}
            />

            </Col>
        </Row>
        <Row>
          <Col className={styles.actions} md={12}>
            <Button
              text={
                this.props.saving
                  ? `${this.localizedCommonActions.saving}...`
                  : this.localizedCommonActions.save
              }
              icon="paperflite-tick"
              variant="primary"
              className={styles.save}
              disabled={this.props.saving}
              onClick={this._handleSaveClick}
            />
            <Button
              text={
                this.state.create
                  ? this.localizedCommonActions.cancel
                  : this.localizedCommonActions.reset
              }
              disabled={this.props.saving}
              onClick={this._handleResetClick}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

export default NDADetailsView;
